<template>
  <div id="app">
    <el-container>
      <el-header
        style="
          height: 150px;
          width: 65%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="logo">
         
          <img src="./assets/img/logo.png" />
          <span>
            焦作市职业健康培训平台</span>
        </div>
        <img
          src="./assets/img/phone.png"
          alt
          style="margin-left: 100px; margin-top: 50px"
        />
        <div class="contact-info">
          <span>咨询时间：周一至周五(08:30--17:30)</span>
          <span>客服热线： <span style="font-size: 16px; font-weight: 800; color: #1476d1"
            >(0391)8861306&nbsp;&nbsp;&nbsp;(0391)8861309</span>
           
          </span>
         
        </div>
        <div class="contact-button">
          <a href="https://jzzyws.hnzhtxx.cn/front/pages/login/login"  target="_blank">
            <el-button type="primary" style="background-color: #3C74C4;" >登录</el-button>
          </a>

          <a href="https://jzzyws.hnzhtxx.cn/front/pages/login/register" target="_blank" style="margin-left: 10px;">
            <el-button type="success" style="background-color: #84AE5A;">注册</el-button>
          </a>
        </div>
      </el-header>
      <div>
        <el-menu  
          style="
            background-color: #1476d1;
            display: flex;
            justify-content: center;
          "
          :default-active="defaultActive"
          class="el-menu-demo"
          background-color="#1476d1"
          text-color="white"
          mode="horizontal"
           active-text-color="#0c61b1 "
          :router="router"
        >
          <el-menu-item index="/" >  <h3 style="color: white;">首页</h3></el-menu-item>
          <el-menu-item
            index="/advers"
            style="margin-left: 150px;"
            ><h3 style="color: white;">通知公告</h3></el-menu-item
          >
          <el-menu-item
            index="/policy"
            style="margin-left: 150px; "
            ><h3 style="color: white;">政策法规</h3></el-menu-item
          >
          <el-menu-item
            index="/publicclass"
            style="margin-left: 150px; "
            ><h3 style="color: white;">公益课程</h3></el-menu-item
          >
          <el-menu-item
            index="/contactus"
            style="margin-left: 150px; "
            ><h3 style="color: white;">联系我们</h3></el-menu-item
          >
        </el-menu>
      </div>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <p>主办单位：焦作市疾病预防控制中心&nbsp;&nbsp;&nbsp;焦作市预防医学会&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;技术支持：河南政汇通信息技术有限公司
          &nbsp;&nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn/" target="_blank" >
           豫ICP备16001785号-2</a> </p>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
    };
  },
  methods: {},
  watch: {
    // 监听路由变化，动态更新菜单选中项
    $route(to) {
     window.console.log("to",to)
      if (to.name === 'adversdetails') {
        // 如果跳转到adversdetails 页面，激活 "对应的页面" 菜单
        this.defaultActive = '/advers';
      }
      if (to.name === 'policydetails') {
        this.defaultActive = '/policy';
      }
      if (to.name ==='classdetails') {
        this.defaultActive = '/publicclass';
      }
      if (to.name ==='home') {
        this.defaultActive = '/';
      }
    }
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  padding: 0 20px; /* 添加一些内边距 */

  .logo {
  display: flex;         /* 使用 flexbox 布局 */
  align-items: center;   /* 垂直居中对齐 */
  font-size: 26px;
  font-weight: 800;
  padding: 50px 0;
  width: 450px;
}

.logo img {
  margin-right: 10px;    /* 图片和文字之间的间距 */
  width: 50px;
}
  .contact-info {
    margin-top: 50px;
    display: flex;
    flex-direction: column; /* 上下排列 */
    align-items: flex-start;
  }

  .contact-info span {
    margin-bottom: 10px; /* 添加间隔 */
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  height: 50px;
  overflow: hidden;
  background-color: #1476D1;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    color: white;
    font-size: 16px;
  }
     a{
    color: white;
    font-size: 16px;
    text-decoration:none;
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
.el-button{
  line-height: 1 !important;
  font-size: 20px !important;
  border-radius: 10px !important;
}

/* 设置选中的菜单项背景色 */
.el-menu-item.is-active {
  background-color: #0c61b1 !important; /* 设置选中项背景 */
}
</style>
